export default {
    roomGroupList: [],
    groupRoomDoc: {},
    isModalSubject: false,
    subjectRoomGroupId: '',
    isNewUser: false,
    loadingGroupMode: false,
    selectedPin: '',
    selectedUserIdList: [],
    isSetNewGroup: false,
}